import React, { useContext } from 'react'
import { 
  Container,
} from './style'
import BasicFields from './Basic'
import MoreOptionsFields from './MoreOptions'
import CertificatesContext from '../../../../contexts/CertificatesContext'
import SupplierFileComponent from './SupplierFile'

const CertificateFields: React.FC = () => {
  const { forWhom } = useContext(CertificatesContext)
  
  return (
      <Container>
        <BasicFields/>
        {forWhom === 'customer' ? <MoreOptionsFields /> : <SupplierFileComponent />}
      </Container>
  )
}
export default CertificateFields